import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "reminder_add",
  "use": "reminder_add-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"reminder_add\"><path d=\"M10 2c.34 0 .675.028 1 .083V3.1A5 5 0 0 0 5 8v4.303l-.168.252L3.87 14h12.26l-.963-1.445-.168-.252V9h1v3l.964 1.445A1 1 0 0 1 16.13 15H13a3 3 0 0 1-6 0H3.869a1 1 0 0 1-.833-1.555L4 12V8a6 6 0 0 1 6-6Zm2 13H8l.005.15A2 2 0 0 0 12 15Zm4-13v2h2v1h-2v2h-1V5h-2V4h2V2h1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol